module.exports = new __parcel__URL__("platform.80c48446.png").toString();